import React, { Component, useState, useEffect } from 'react'
import Loader from '../Loader/Loader';
import Helper from '../Helper'
import useStateRef from 'react-usestateref';
import { Modal } from '../Modal/Modal';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import BreadCrumbsContainer from '../BreadCrumbs/BreadCrumbsContainer';
import { miniCartItemCountAction } from '../../middleware/miniCartItemCountAction';
import { useSelector, useDispatch } from 'react-redux';
import { APPLICATION_JSON } from '../../middleware/types';
import { getShoppingListDetails } from '../../middleware/getShoppingListDetails';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import CbLoginModal from "../CbLogin/CbLoginModal";
export const PublicListDetail = ({ containerObject, templateName, contentId, dataZone }) => {

    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [errorMessage, setErrorMessage] = useState();
    const [friendList, setFriendList, friendListRef] = useStateRef('')
    const [listDetail, setListDetail, listDetailRef] = useStateRef('')
    const [giftItem, setGiftItems, giftItemRef] = useStateRef('')
    const [url, setUrl, setUrlRef] = useStateRef("");
    const [responseList, setResponseList, responseListRef] = useStateRef('')
    const [responseListDetail, setResponseListDetail, responseListDetailRef] = useStateRef('')
    const [responseListItemDetail, setResponseListItemDetail, responseListItemDetailRef] = useStateRef('')
    const [productList, setProductList, setProductListRef] = useStateRef([]);
    const [shoppingListId, setShoppingListId] = useState();
    const [productDetailList, setProductDetailList, productDetailListRef] = useStateRef();
    const [isModalopen, setIsModalOpen] = useState(false);
    const [productErrorMsg, setProductErrorMsg, productErrorMsgRef] = useStateRef('');
    const [selectAllProduct, setSelectAllProduct] = useState(false);
    const [productId, setProductId, productIdRef] = useStateRef("")
    const [addListToCartResponse, setAddListResponse, addListToCartResponseRef] = useStateRef("");
    const [invalidProduct, setInvalidProduct, invalidProductRef] = useStateRef("");
    const [userName, setUserName, userNameRef] = useStateRef('')
    const [profileId, setProfileId, profileIdRef] = useStateRef('')
    const history = useHistory()
    const [addListToCart, setAddListToCart, addListToCartRef] = useStateRef()
    const dispatch = useDispatch();
    const GetCartCount = useSelector(state => state.miniCartItemCountReducer.response.payload)
    const [selectedProductIds, setSelectedProductIds] = useState()
    const [searchValue, setSearchValue, searchValueRef] = useStateRef('')
    const shoppingListDetails = useSelector(state => state.getShoppingListDetails.listDetails)
    const [displayNameAccend, setDisplayNameAccend] = useState(true);
    const [catalogRefIdAccend, setCatalogRefIdAccend] = useState(true);
    const [quantityDesiredAccend, setQuantityDesiredAccend] = useState(true);
    const [priceAccend, setPriceAccend] = useState(true);
    const [selectedValue, setSelectedValue, selectedValueRef] = useStateRef('')
    const profileDetail = useSelector(state => state.getProfileDetails.profileDetails)
    useEffect(() => {
        setIsLoading(false)
        setHasError(false)
        var searchParam = window.location.search
        // console.log("searchParam",searchParam)
        // console.log("gift-parm",searchParam.get("giftlistId"))
        // console.log("profile-parm",searchParam.get("profileId"))
        setUrl(searchParam)
        const params = new URLSearchParams(searchParam);
        var prodId = params.get('profileId')
        var giftlistId = params.get('giftlistId')
        setProductId(prodId)
        setShoppingListId(giftlistId)
        if (prodId && giftlistId) {
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/find-friends/shopping-list-details/${giftlistId}/${prodId}`, {
                credentials: "include",
                method: "GET",
                headers: new Headers({
                    "content-Type": "application/json",
                })
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setResponseListDetail(res)
                        setListDetail(res.listDetail)
                        setGiftItems(res.giftItems)
                        // document.getElementById("add-list-to-cart-error").classList.remove("d-block");
                        // document.getElementById("add-list-to-cart-error").classList.add("d-none");
                        // setIsLoading(true)
                        const titleElement = document.querySelector('title')
                        if (listDetailRef.current && listDetailRef.current.Name) {
                            titleElement.innerHTML = listDetailRef.current.Name + " | Carolina Biological Supply"
                        } else {
                            titleElement.innerHTML = "Carolina Biological Supply"
                        }
                    } else {
                        setIsLoading(false)
                        const error = res._ERROR_MESSAGE_;
                        setErrorMessage(error);
                    }
                })
        }
    }, [])

    useEffect(() => {
        // setIsLoading(true)
        var searchParam = window.location.search
        setUrl(searchParam)
        const params = new URLSearchParams(searchParam);
        setProfileId(params.get('profileId'))
        var id = params.get('profileId')
        if (id) {
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/find-friends/shopping-list/${id}`, {
                method: 'GET'
            }).then(res => res.json())
                .then(res => {
                    if (res.response != null) {
                        var friendListDetatils = res.response.response
                        setFriendList(friendListDetatils)
                        {
                            friendListRef.current && friendListRef.current.map((value, key) => {
                                return (
                                    (value && value.userName &&
                                        setUserName(value.userName)
                                    )
                                )
                            })
                        }
                        // setIsLoading(true)
                    }
                })
        }
    }, [])

    const handleAddListToCart = (event) => {
        event.preventDefault();
        setProductErrorMsg()
        event.preventDefault();
        setIsModalOpen(false)
        setIsLoading(false)
        setHasError(false)
        var index = 0
        var searchParam = window.location.search
        const params = new URLSearchParams(searchParam);
        var productIdList = []
        var prodIdsList = null;
        var productDetailList = []
        var prodDetailList = null;
        {
            giftItemRef.current && giftItemRef.current.map((itemDetail, index) => {
                productIdList.push(itemDetail.productId)
                productDetailList.push(itemDetail.productId + ":" + itemDetail.quantity)
            })
        }
        if (productIdList.length > 0) {
            prodIdsList = productIdList.join(",")
            prodDetailList = productDetailList.join(",")
        }
        var eventName = listDetailRef.current.Name ? listDetailRef.current.Name : ""
        var description = listDetailRef.current.Description ? listDetailRef.current.Description : ""
        var isPublic = true
        if (params) {
            const inputMap = {
                skuIdsList: prodIdsList != null ? prodIdsList : "",
                prodIdsList: prodIdsList != null ? prodIdsList : "",
                giftlistId: params.get('giftlistId'),
                eventName: eventName,
                description: description,
                isPublic: isPublic,
                isPublished: isPublic,
                productDetails: prodDetailList
            }

            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-details/add-list-to-cart`, {
                credentials: "include",
                method: "POST",
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setIsLoading(false)
                        var responseData = res.response;
                        setAddListResponse(res.response.response.response.validproducts)
                        handleSiteSpecDataLayer(res?.response?.response?.response?.validproducts)
                        setIsModalOpen(true)
                        if (res.response.response.response.invalidProducts &&
                            (res.response.response.response.invalidProducts.length > 0)) {
                            setInvalidProduct(res.response.response.response.invalidProducts)
                        } else {
                            setInvalidProduct()
                        }
                        // var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/mini-cart-count`
                        // dispatch(miniCartItemCountAction(Url))
                        dispatch(updateProfileDetailsAction(true, "cart"));
                        var addListBtn = document.getElementById("addList");
                        addListBtn.setAttribute("data-bs-toggle", "modal");
                        addListBtn.setAttribute("data-bs-target", `#addProductToCartModal${index}`);
                        addListBtn.click();
                        let addToListDL = {
                            event: "list_detail_add_cart_item"
                        }

                        window.dataLayer = window.dataLayer || []
                        if (window.dataLayer.length > 0) {
                            window.dataLayer.push(addToListDL)
                        }

                    } else {
                        setIsLoading(false)
                        const error = res.errorMessage;
                        setErrorMessage(error);
                        document.getElementById("add-list-to-cart-error").classList.remove("d-none");
                        document.getElementById("add-list-to-cart-error").classList.add("d-block");
                    }
                })
        }
    }


    function handleSiteSpecDataLayer(validateProduct) {
        let productList = []
        {
            validateProduct?.map((oneProduct) => {
                let categoryList = [];
                let category = JSON.parse(oneProduct?.dataLayer_obj)
                const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];

                categoryList = categoryList1;
                const productMapDuplicate = {
                    "productId": oneProduct.ProductId,
                    "category": categoryList
                }
                let productMap = productMapDuplicate;
                productList.push(productMap)
            })
        }

        const page = {
            "type": "product",
            "products": productList
        }
        const PLD_payload = {
            "page": page
        }
        window.ssRecsInfo = window.ssRecsInfo || {}
        window.ssRecsInfo = PLD_payload
        window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': PLD_payload}))
    }
    useEffect(() => {
        if (shoppingListDetails) {
            setResponseList(shoppingListDetails)
        } else {
            //  setIsLoading(false)
        }
    }, [])
    const handleSelectedvalue = (event) => {
        setSelectedValue(event.target.value)
        history.push("/account/list-detail-public?giftlistId=" + selectedValueRef.current + "&profileId=" + profileIdRef.current)
    }
    const handleList = (event) => {
        history.push("/account/list-detail-public?giftlistId=" + event + "&profileId=" + profileIdRef.current)
    }
    //breadcrumbs object 
    const breadCrumbs = {
        "ancestors": [{
            label: listDetailRef.current.OwnerName + "'s Lists",
            link: "/account/list-public?id=" + productIdRef.current
        },
        {
            label: listDetailRef.current.Name,
            link: setUrlRef.current
        }
        ],
        productName: ""
    };
    async function handleAddProductToCart(event, index) {
        let addToCartDL = {
            event: "list_detail_add_cart_item"
        }

        window.dataLayer = window.dataLayer || []
        if (window.dataLayer.length > 0) {
            window.dataLayer.push(addToCartDL)
        }

        document.getElementById("add-item-error-message").classList.remove("d-block")
        document.getElementById("add-item-error-message").classList.add("d-none")
        var searchParam = window.location.search
        const params = new URLSearchParams(searchParam);
        var productId = event.productId;
        var index = index ? index : 0;
        const selectedListsInArray = productId ? [productId] : selectedProductIds && selectedProductIds ? selectedProductIds : [];
        Helper.clearErrorMsg()
        var shoppingListDetatils = giftItemRef.current
        if (params) {
            const data = {
                eventName: listDetailRef.current && listDetailRef.current.Name ? listDetailRef.current.Name : "",
                description: listDetailRef.current && listDetailRef.current.Description ? listDetailRef.current.Description : "",
                isPublic: true,
                isPublished: true,
                giftlistId: params.get('giftlistId'),
                itemIdsList: "",
                removeGiftitemIds: "",
                updateGiftlistItemsSuccessURL: "/account/list-detail",
                updateGiftlistItemsErrorURL: "/account/list-detail"
            }
            var actionUrl = "api/rest/cb/shopping-list/shopping-list-details/add-products-to-cart";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                data: data,
                selectedProduct: selectedListsInArray,
                giftListItems: shoppingListDetatils
            }))
            if (res.result == "success") {

                setAddListResponse(res.response.response.response.validproducts)
                handleSiteSpecDataLayer(res?.response?.response?.response?.validproducts)
                if (res.response.response.response.invalidProducts && res.response.response.response.invalidProducts.length > 0) {
                    setInvalidProduct(res.response.response.response.invalidProducts)
                } else {
                    setInvalidProduct()
                }
                dispatch(updateProfileDetailsAction(true, "cart"));
                var addListBtn = document.getElementById("addList");
                addListBtn.setAttribute("data-bs-toggle", "modal");
                addListBtn.setAttribute("data-bs-target", `#addProductToCartModal${index}`);
                addListBtn.click();
                document.getElementById("listsProduct").checked = false;
                setIsLoading(false)
                let productIds = [];
                addListToCartResponseRef.current?.map((oneProduct) => {
                    productIds.push(oneProduct.ProductId);
                 })

                let addToCartDL = {
                    event: "list_detail_add_cart_item",
                    list_items:productIds
                }

                window.dataLayer = window.dataLayer || []
                if (window.dataLayer.length > 0) {
                    window.dataLayer.push(addToCartDL)
                }
                
            }
            else {
                setIsLoading(false)
                setProductErrorMsg(res.errorMessage)
                document.getElementById("add-item-error-message").classList.remove("d-none")
                document.getElementById("add-item-error-message").classList.add("d-block")
            }
        }
    }

    const searchListItem = async (e) => {
        // setSearchValue(searchValue)
        // setGiftItems(sortProducts())
        handleUnselectAllCheckbox()
        var searchValue = e.target.value;
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const giftlistId = params.get('giftlistId');
        if (params) {
            var actionUrl = "api/rest/cb/shopping-list/shopping-list-details/search-list-item";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}/searchValue=${searchValue}/${giftlistId}`
            var res = await Helper.fetchCallFunction(Url, "GET", false, "", "")
            if (res.result == "success") {
                var shoppingListDetatils = (JSON.parse(res.response)).response
                //setResponseListDetail(shoppingListDetatils)
                setGiftItems(shoppingListDetatils)
            } else {
                //  setIsLoading(false)
            }
        }
    }
    const sortProducts = () => {
        return responseListDetailRef.current && responseListDetailRef.current.giftItems ? responseListDetailRef.current.giftItems.filter(product =>
            product.productName.toLowerCase().startsWith(searchValueRef.current.toLowerCase())
        ) : "";
    };
    const handleSelectAllCheckbox = (event) => {
        var selected = [];
        var tables = document.getElementById("listItems");
        var chks = tables.getElementsByClassName("product");
        for (var i = 0; i < chks.length; i++) {
            if (event.target.checked) {
                chks[i].checked = true;
            } else {
                chks[i].checked = false;
            }
            if (chks[i].checked) {
                selected.push(chks[i].id);
            }
            setSelectedProductIds(selected)
        }
    };
    const handleUnselectAllCheckbox = (event) => {
        var tables = document.getElementById("listItems");
        var chks = tables.getElementsByClassName("product");
        for (var i = 0; i < chks.length; i++) {
            chks[i].checked = false;
            setSelectedProductIds("")
        }
    };
    const handleIndividualChecked = (event) => {
        var selected = [];
        var tables = document.getElementById("listItems");
        var chks = tables.getElementsByClassName("product");
        for (var i = 0; i < chks.length; i++) {
            if (chks[i].checked) {
                selected.push(chks[i].id);
            } else {
                document.getElementById("listsProduct").checked = false;
            }
        }
        setSelectedProductIds(selected)
    };
    const handleCopyList = () => {

        let copyListDL = {
            event: "list_detail_copy"
        }

        window.dataLayer = window.dataLayer || []
        if (window.dataLayer.length > 0) {
            window.dataLayer.push(copyListDL)
        }
        if (profileDetail && profileDetail.transient) {
            var copyListBtn = document.getElementById("addList");
            copyListBtn.setAttribute("data-bs-toggle", "modal");
            copyListBtn.setAttribute("data-bs-target", "#loginModal");
            copyListBtn.click();
        } else {
            var copyListBtn = document.getElementById("addList");
            copyListBtn.setAttribute("data-bs-toggle", "modal");
            copyListBtn.setAttribute("data-bs-target", `#copyListModal${0}`);
            copyListBtn.click();
        }
    }
    const handleSortingChange = (event) => {
        document.getElementById("displayName").classList.remove("sort-up")
        document.getElementById("displayName").classList.remove("sort-down")
        document.getElementById("catalogRefId").classList.remove("sort-up")
        document.getElementById("catalogRefId").classList.remove("sort-down")
        document.getElementById("quantityDesired").classList.remove("sort-up")
        document.getElementById("quantityDesired").classList.remove("sort-down")
        document.getElementById("price").classList.remove("sort-up")
        document.getElementById("price").classList.remove("sort-down")

        var accend = true
        if (event == "displayName") {
            accend = displayNameAccend
            if (displayNameAccend == true) {
                document.getElementById("displayName").classList.remove("sort-down")
                document.getElementById("displayName").classList.add("sort-up")
            } else {
                document.getElementById("displayName").classList.remove("sort-up")
                document.getElementById("displayName").classList.add("sort-down")
            }
        } else if (event == "catalogRefId") {
            accend = catalogRefIdAccend
            if (catalogRefIdAccend == true) {
                document.getElementById("catalogRefId").classList.remove("sort-down")
                document.getElementById("catalogRefId").classList.add("sort-up")
            } else {
                document.getElementById("catalogRefId").classList.remove("sort-up")
                document.getElementById("catalogRefId").classList.add("sort-down")
            }
        } else if (event == "quantityDesired") {
            accend = quantityDesiredAccend
            if (quantityDesiredAccend == true) {
                document.getElementById("quantityDesired").classList.remove("sort-down")
                document.getElementById("quantityDesired").classList.add("sort-up")
            } else {
                document.getElementById("quantityDesired").classList.remove("sort-up")
                document.getElementById("quantityDesired").classList.add("sort-down")
            }
        } else if (event == "price") {
            accend = priceAccend
            if (priceAccend == true) {
                document.getElementById("price").classList.remove("sort-down")
                document.getElementById("price").classList.add("sort-up")
            } else {
                document.getElementById("price").classList.remove("sort-up")
                document.getElementById("price").classList.add("sort-down")
            }
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/friend-list-detail-sort/${shoppingListId}/${event}/${accend}`, {
            method: 'GET',
            headers: new Headers({
                "content-Type": "application/json",
            })
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    if (event == "displayName") {
                        if (displayNameAccend == true) {
                            setDisplayNameAccend(false)
                        } else {
                            setDisplayNameAccend(true)
                        }
                    } else if (event == "catalogRefId") {
                        if (catalogRefIdAccend == true) {
                            setCatalogRefIdAccend(false)
                        } else {
                            setCatalogRefIdAccend(true)
                        }
                    } else if (event == "quantityDesired") {
                        if (quantityDesiredAccend == true) {
                            setQuantityDesiredAccend(false)
                        } else {
                            setQuantityDesiredAccend(true)
                        }
                    } else if (event == "price") {
                        if (priceAccend == true) {
                            setPriceAccend(false)
                        } else {
                            setPriceAccend(true)
                        }
                    }
                    if (JSON.parse(res.response)) {
                        setGiftItems(JSON.parse(res.response))
                    }
                }
            })
    }
    function handlePrintPage() {
        window.print()
    }
    return (
        <>
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail c-shop-list-detail-mobile-view`} >
                <div class="row">
                    <div className="col-md-11">
                        {listDetailRef.current && listDetailRef.current.Name != null &&
                            <BreadCrumbsContainer breadCrumbs={breadCrumbs} pageType="FriendListDetail"></BreadCrumbsContainer>
                        }
                    </div>
                    <div className="col-12 col-md-1 d-none d-lg-block" style={{ marginLeft: "-20px" }}>
                        <button className="btn btn-light c-print-btn text-end" type="button" onClick={handlePrintPage}>
                            <i className="bi bi-printer-fill" aria-hidden="true"></i>Print
                        </button>
                    </div>
                </div>
                <div id="add-item-error-message" class="col-lg-12 alert alert-danger d-none" role="alert">
                    <p>{productErrorMsg}</p>
                </div>
                <div id="content" class="col-lg-9 m-md-auto">
                    <div id="shoppingList" data-hs-cf-bound="true">
                        <div class="row my-3 my-md-3">
                            <div class="col-6 col-md-6">
                                <h1 class="c-account-list-heading">{listDetailRef.current.Name}</h1>
                            </div>
                            <div class="col-12 col-md-6 text-md-end text-center my-2 my-md-0">
                                <select className="form-select c-list-details-select" onChange={handleSelectedvalue} id="listSelect">
                                    <option disabled="disabled">View a Different List...</option>

                                    {friendListRef.current && friendListRef.current.map((value, key) => {

                                        return (
                                            <>
                                                {value && value.Name && listDetailRef.current.Name == value.Name ?
                                                    <option value={value.giftlistId} selected >{value.Name}</option> :
                                                    <option value={value.giftlistId} >{value.Name}</option>
                                                }</>
                                        )
                                    })
                                    }
                                </select>
                            </div>
                        </div>
                        <div class="row c-shopping-details-page">
                            <div class="col-md-8">
                                <div class="mb-3 row">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">List Owner:</label>
                                    <div class="col-sm-8 my-md-2"><span>{listDetailRef.current.OwnerName}</span></div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="staticEmail" class="col-sm-4 col-form-label">List Description:</label>
                                    <div class="col-sm-8 my-md-2"><span>{listDetailRef.current.Description}</span></div>
                                </div>
                                <hr />
                            </div>
                            <div class="col-md-4">
                                <div class="c-details-right-actions">
                                    <p id="addList"></p>
                                    <Link className="btn bt btn-secondary mb-2" onClick={handleAddListToCart}>Add List to Cart</Link>
                                    <button type="button" className="btn btn-secondary mb-2 modal-btn" onClick={handleCopyList}>Copy List</button>
                                </div>
                            </div>
                            <div class="row c-shopping-list-page align-items-center my-3">
                                <div class="col-12 col-md-9">
                                    <div class="row g-1">
                                        <label className="col-md-3 col-form-label c-shopping-list-label">Search List:</label>
                                        <div className="col-10 col-md-7">
                                            <input type="text" placeholder="Keyword or Item #" className="form-control" id="searchKeyword" onChange={searchListItem} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="c-list-bar d-none d-md-flex">
                                <div class="c-listbar-left">
                                    <label class="m-hide">Selected items</label>
                                    <input type="button" className="btn c-shop-btn" value="Add to Cart" onClick={handleAddProductToCart} />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="c-list-table">
                                        <h1 class="c-mobile-list-heading d-block d-md-none">My Lists</h1>
                                        <ul class="c-shop-list">

                                            <li class="c-shop-list-item c-shop-list-header d-none d-md-flex">
                                                <div class="c-list-left">
                                                    <span class="c-shop-list-content c-shop-list-check">
                                                        <input type="checkbox" id="listsProduct" onChange={handleSelectAllCheckbox} className="select-all-checkbox form-check-input" />
                                                    </span>
                                                    <span class="c-shop-list-content c-shop-list-name">Description <Link className="sort" id="displayName" onClick={() => handleSortingChange("displayName")}></Link></span>
                                                    <span class="c-shop-list-content c-shop-list-items">Item # <Link className="sort" id="catalogRefId" onClick={() => handleSortingChange("catalogRefId")}></Link></span>
                                                    <span class="c-shop-list-content c-shop-list-created"># Needed <Link className="sort" id="quantityDesired" onClick={() => handleSortingChange("quantityDesired")}></Link></span>
                                                    <span class="c-shop-list-content c-shop-list-total text-md-end">Price <Link className="sort" id="price" onClick={() => handleSortingChange("price")}></Link></span>
                                                </div>
                                            </li>

                                        </ul>
                                        <ul class="c-shop-list item item-list item-cart" id="listItems">
                                            {giftItemRef.current && giftItemRef.current.map((itemDetail, index) => {

                                                return (<>
                                                    <li class="c-shop-list-item c-shop-list-body">
                                                        <div class="c-list-left">
                                                            <span class="c-shop-list-content c-shop-list-check">
                                                                <input type="checkbox" onChange={handleIndividualChecked} id={`${itemDetail.productId}`} className="product form-check-input" name="productCheck" />
                                                            </span>
                                                            <span class="c-shop-list-content c-shop-list-name c-shop-details-product">
                                                                <Link class="c-shop-details-img">
                                                                    <img src={itemDetail.thumbnailImg} /></Link>
                                                                <Link to={itemDetail && itemDetail.productUrl ? itemDetail.productUrl : ""} class="c-shop-details-title fw-bold" dangerouslySetInnerHTML={{ __html: itemDetail.productName }}></Link>
                                                                {itemDetail && itemDetail.cautionUrl &&
                                                                    <ul class="c-shop-list-icons">
                                                                        <li><img src="/images/icon-warning-caution.gif" /></li>
                                                                    </ul>}
                                                                {itemDetail && itemDetail.geographicUrl &&
                                                                    <ul class="c-shop-list-icons">
                                                                        <li><img src="/images/icon-warning-geographic.gif" /></li>
                                                                    </ul>
                                                                }
                                                            </span>
                                                            <span class="c-shop-list-content c-shop-list-items">
                                                                <span class="d-block d-md-none c-shop-mobile-label">#Items</span>
                                                                <strong>{itemDetail.productId}</strong>
                                                            </span>
                                                            <span class="c-shop-list-content c-shop-list-items text-md-start">
                                                                <span class="d-block d-md-none c-shop-mobile-label">
                                                                    <strong>QTY</strong>
                                                                </span>
                                                                <span>
                                                                    <strong>{itemDetail.quantity}</strong>
                                                                </span>
                                                            </span>
                                                            <span class="c-shop-list-content c-shop-list-total text-md-end">
                                                                {/* <strong>{itemDetail.price ? itemDetail.price : ""}</strong> */}
                                                                <strong>{itemDetail.itemPrice}</strong>
                                                                {itemDetail && itemDetail.retailPrice && <span class="c-list-retail"><i>{` Retail `}
                                                                    <del>{itemDetail.retailPrice}</del></i></span>}
                                                                <span class="c-details-add d-block">
                                                                    <input type="button" class="btn btn-primary mt-md-2" onClick={() => handleAddProductToCart(itemDetail, index)} value="Add to Cart" />
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <Modal index={index} giftlistId={shoppingListId} props={addListToCartResponseRef.current} invalidProduct={invalidProductRef.current} />
                                                </>)
                                            })}
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

            <CbLoginModal />
        </>
    )
}
